import usePageMetadata from "./usePageMetadata";

const useIsSignedIn = () => {
  const { localDB } = usePageMetadata();
  const token_key = `${localDB.name}_token`;
  const token = localStorage.getItem(token_key);
  return token != null;
};

export default useIsSignedIn;
